/**
 * catalog-loader.js
 *
 * Replaces the static data.js + categories.generated.js script tags.
 * Fetches catalog.json from the REST API, populates the same globals
 * that app.js already expects (window.CATALOG_DATA / window.CATALOG_CATEGORIES),
 * then dynamically loads app.js.
 *
 * Configuration (set in index.html before this script):
 *   window.CATALOG_CONFIG = {
 *     apiUrl: "",          // Base URL of the Function App, e.g. "https://my-fn.azurewebsites.net"
 *                          // Leave empty to use relative /api/ paths.
 *     mode:   "api",       // "api" (default) | "static" (use local data.js / categories.generated.js)
 *   };
 */
(function () {
  "use strict";

  var config  = window.CATALOG_CONFIG || {};
  var apiUrl  = (config.apiUrl  || "").replace(/\/$/, "");
  var mode    = config.mode || "api";
  var loadingEl = document.getElementById("app-loading");
  var loadingMessageEl = document.getElementById("app-loading-message");
  var loadingDepth = 0;

  function setLoadingVisible(visible, message) {
    if (loadingMessageEl && message) {
      loadingMessageEl.textContent = message;
    }

    if (!loadingEl) return;

    loadingEl.classList.toggle("is-hidden", !visible);
    loadingEl.setAttribute("aria-hidden", visible ? "false" : "true");
    document.body.classList.toggle("is-loading", visible);
  }

  function showLoading(message) {
    loadingDepth += 1;
    setLoadingVisible(true, message);
  }

  function hideLoading() {
    loadingDepth = Math.max(loadingDepth - 1, 0);
    if (loadingDepth === 0) {
      setLoadingVisible(false);
    }
  }

  window.PartsCatalogLoading = {
    show: showLoading,
    hide: hideLoading,
  };

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s   = document.createElement("script");
      s.src   = src;
      s.async = false;
      s.onload  = resolve;
      s.onerror = function () { reject(new Error("Failed to load script: " + src)); };
      document.head.appendChild(s);
    });
  }

  function loadStaticFallback() {
    return loadScript("categories.generated.js")
      .then(function () { return loadScript("data.js"); })
      .then(function () { return loadScript("app.min.js"); });
  }

  function loadFromApi() {
    return fetch(apiUrl + "/api/catalog")
      .then(function (r) {
        if (!r.ok) {
          throw new Error("Catalog API returned HTTP " + r.status);
        }
        return r.json();
      })
      .then(function (catalog) {
        // Populate the exact same globals that app.js reads
        window.CATALOG_CATEGORIES = catalog.categories;
        window.CATALOG_DATA = {
          categories:       catalog.categories,
          partsByCategory:  catalog.partsByCategory,
          partDetails:      catalog.partDetails,
          locationHotspots: catalog.locationHotspots,
        };
        return loadScript("app.min.js");
      });
  }

  function bootstrapWithLoading(loadFn, message) {
    showLoading(message || "Loading parts...");
    return loadFn().finally(function () {
      hideLoading();
    });
  }

  if (mode === "static") {
    bootstrapWithLoading(loadStaticFallback, "Loading parts...");
  } else {
    bootstrapWithLoading(loadFromApi, "Loading parts...").catch(function (err) {
      console.warn(
        "[catalog-loader] Failed to load catalog from API (" + err.message + ").",
        "Falling back to static data files."
      );
      return bootstrapWithLoading(loadStaticFallback, "Loading parts...");
    });
  }
})();
